/**
 * Styled components for Journey Editor Header
 */

import styled from 'styled-components';
import { Box } from '@usealloy/component-library';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid var(--cl-gray-200);
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--cl-space-6) var(--cl-space-2) var(--cl-space-6);
  gap: var(--cl-space-6);
`;

export const VersionInfoContainer = styled(Box).attrs({
  direction: 'row',
  gap: 2,
  alignItems: 'center',
})`
  width: auto;
`;

export const VersionBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--cl-space-3);
`;

